"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../index");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _NotificationHandler = _interopRequireDefault(require("../../handlers/NotificationHandler"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Notification = /*#__PURE__*/function (_Component) {
  function Notification(props) {
    var _this;
    _classCallCheck(this, Notification);
    _this = _callSuper(this, Notification, [props]);
    _defineProperty(_this, "hideTimer", null);
    _defineProperty(_this, "alertDefinition", null);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.setNewState = _this.setNewState.bind(_this);
    _this.setStateFromProps = _this.setStateFromProps.bind(_this);
    _this.isShowing = _this.isShowing.bind(_this);
    _this.handlePushable = _this.handlePushable.bind(_this);
    _this.alertDefinition = _this.setStateFromProps(props);
    _this.state = _this.setStateFromProps(props);
    return _this;
  }
  _inherits(Notification, _Component);
  return _createClass(Notification, [{
    key: "show",
    value: function show() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState({
          display: true
        });
        if (!_this2.state.showCloseBtn) {
          clearTimeout(_this2.hideTimer);
          _this2.hideTimer = setTimeout(function () {
            _NotificationHandler["default"].hide();
          }, _this2.state.hideAfter);
        }
      }, this.state.showAfter);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        display: false
      });
      if (this.state.closeCallback) {
        this.state.closeCallback();
      }
    }
  }, {
    key: "setNewState",
    value: function setNewState(state) {
      this.setState(this.setStateFromProps(state));
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this.state.display;
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps(props) {
      var nextProps = props || {};
      var definition = this.alertDefinition || {};
      var newState = {
        pushable: nextProps.pushable !== undefined ? nextProps.pushable : definition.pushable !== undefined ? definition.pushable : true,
        display: this.state ? this.state.display : false,
        colorTheme: nextProps.colorTheme || definition.colorTheme || 'soft-chill',
        className: nextProps.className || definition.className || '',
        text: nextProps.text || definition.text || null,
        buttons: nextProps.buttons || definition.buttons || null,
        style: nextProps.style || definition.style || {},
        hideAfter: nextProps.hideAfter || definition.hideAfter || 5000,
        showAfter: nextProps.showAfter || definition.showAfter || 0,
        transitionTime: nextProps.transitionTime || definition.transitionTime || 200,
        closeCallback: nextProps.closeCallback || definition.closeCallback || null,
        showCloseBtn: nextProps.showCloseBtn !== undefined ? nextProps.showCloseBtn : definition.showCloseBtn !== undefined ? definition.showCloseBtn : true
      };
      if (newState.showCloseBtn) {
        clearTimeout(this.hideTimer);
      }
      return newState;
    }
  }, {
    key: "handlePushable",
    value: function handlePushable() {
      var _this3 = this;
      setTimeout(function () {
        //Keeps has a reminder, 3.5rem should always be element height, unless design change
        //let heightElement = window.document.querySelector('#notification-component').clientHeight;
        if (_this3.state.display === true) {
          window.document.body.style.transition = _this3.state.transitionTime + 'ms all ease-in-out';
          window.document.body.style.marginTop = '3.5rem';
        } else {
          window.document.body.style.marginTop = '0px';
        }
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.pushable === true) {
        this.handlePushable();
      }
      var classes = (0, _classnames["default"])('notification-bar-component', this.state.classeName, this.state.colorTheme, {
        'show': this.state.display
      });
      var styles = {
        transitionDelay: '0ms',
        transitionDuration: "".concat(this.state.transitionTime, "ms"),
        transitionTimingFunction: 'ease',
        top: '-100px'
      };
      var right = /*#__PURE__*/_react["default"].createElement("div", null);
      if (this.state.showCloseBtn) {
        right = /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
          onClick: function onClick() {
            _NotificationHandler["default"].hide();
          },
          name: "glyph-remove"
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "notification-component",
        className: classes,
        style: styles
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_index.FullBar, {
        left: /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
          name: "glyph-notifications",
          classNameContainer: "glyph"
        }),
        middle: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
          className: "notification-message"
        }, this.state.text), this.state.buttons !== null && /*#__PURE__*/_react["default"].createElement("div", {
          className: "buttonCol"
        }, this.state.buttons)),
        right: right
      })));
    }
  }]);
}(_react.Component);
Notification.propTypes = {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  buttons: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].object), _propTypes["default"].object]),
  showCloseBtn: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  colorTheme: _propTypes["default"].oneOf(['soft-chill', 'yellow']),
  hideAfter: _propTypes["default"].number,
  showAfter: _propTypes["default"].number,
  transitionTime: _propTypes["default"].number,
  closeCallback: _propTypes["default"].func,
  pushable: _propTypes["default"].bool,
  isExpress: _propTypes["default"].bool,
  isPriority: _propTypes["default"].bool
};
Notification.defaultProps = {};
var _default = exports["default"] = Notification;